import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PageHeaderModule } from "./shared/page-header/page-header.module";
import { SideMenuModule } from "./shared/side-menu/side-menu.module";
import { ForceUpdateModalComponent } from "./shared/force-update-modal/force-update-modal.component";
import { ApiModule, BASE_PATH, Configuration } from "./services/swagger";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { TokenAuthInterceptor } from "./services/token-auth/token-auth.interceptor";
import { environment } from "src/environments/environment";
import { AuthCodeComponent } from "./auth-code.component";
import { DataService } from "./services/preload/data.service";
import { NgxPermissionsModule } from "ngx-permissions";

@NgModule({
  declarations: [AppComponent, AuthCodeComponent, ForceUpdateModalComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true,
      mode: "ios",
    }),
    HttpClientModule,
    ApiModule.forRoot(() => new Configuration()),
    AppRoutingModule,
    PageHeaderModule,
    SideMenuModule,
    NgxPermissionsModule.forRoot(),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TokenAuthInterceptor, multi: true },
    { provide: BASE_PATH, useValue: environment.baseUrl },
    DataService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
